import React from "react";
import { graphql } from "gatsby";
import PropTypes from "prop-types";
import SectionAlternatingLayout from "~components/sections/section_alternating_layout/section_alternating_layout";
import SectionContactForm from "~components/sections/section_contact_form/section_contact_form";
import SectionDeveloperCodeWithQuotes from "~components/sections/section_developer_code_with_quotes/section_developer_code_with_quotes";
import SectionFeatureGrid from "~components/sections/section_feature_grid/section_feature_grid";
import SectionHeroWrapper from "~components/sections/section_hero_wrapper/section_hero_wrapper";
import SectionImageGrid from "~components/sections/section_image_grid/section_image_grid";
import SectionStats from "~components/sections/section_stats/section_stats";
import renderDynamicComponent from "~components/utils/render_dynamic_component/render_dynamic_component";
import usePageData from "~hooks/use_page_data/use_page_data";
import { STORYBLOK_ENTRY } from "../../prop_types";
import TemplateGlobalEntry from "../template_global_entry/template_global_entry";

const TEMPLATE_COMPONENTS = {
  sectionAlternatingLayout: SectionAlternatingLayout,
  sectionContactForm: SectionContactForm,
  sectionDeveloperCodeWithQuotes: SectionDeveloperCodeWithQuotes,
  sectionFeatureGrid: SectionFeatureGrid,
  sectionImageGrid: SectionImageGrid,
  sectionHeroWrapper: SectionHeroWrapper,
  sectionStats: SectionStats,
};

export default function TemplateHomepage(props) {
  const { story, pageContext } = usePageData(props);

  const { children } = story;

  const { subNavData, lang } = pageContext;

  return (
    <TemplateGlobalEntry
      headerColor="white"
      lang={lang}
      subNavData={subNavData}
      {...props}
    >
      {children?.length > 0 &&
        children.map((childComponent) => {
          return renderDynamicComponent({
            parentComponentName: "TemplateHomepage",
            componentName: childComponent.component,
            componentsMap: TEMPLATE_COMPONENTS,
            ...childComponent,
          });
        })}
    </TemplateGlobalEntry>
  );
}

TemplateHomepage.propTypes = {
  data: PropTypes.shape({
    story: STORYBLOK_ENTRY,
  }).isRequired,
  pageContext: PropTypes.shape({
    subNavData: PropTypes.arrayOf(PropTypes.shape({})),
  }),
};

TemplateHomepage.defaultProps = {
  pageContext: {
    subNavData: [],
  },
};
// TODO: get page specific metadata here
export const query = graphql`
  fragment story on Query {
    story: storyblokEntry(id: { eq: $id }) {
      assets {
        ...asset
      }
      content
      full_slug
      group_id
      alternates {
        full_slug
      }
    }
  }

  query TemplateHomepageQuery($id: String, $langRegex: String) {
    ...story
    ...global
  }
`;
